module.exports = __webpack_public_path__ + "img/logo2@2x.155b1501.png";